import { Icon, usePrompt } from '@ur-solutions/react-components'
import type { CellProps } from '@/components_deprecated'
import { Button, Cell } from '@/components_deprecated'
import type { ActivitiesDynamicColumnDayReport } from '@/modules/activities/types.graphql'
import { type MouseEventHandler } from 'react'
import { useParam } from '@/utils'
import styled from 'styled-components'
import { useMutation } from '@apollo/client'
import { format, parseISO } from 'date-fns'
import { ElipsedText } from './DietCell'
import { UPDATE_OR_CREATE_DRIVER_COMMENT_MUTATION } from '../../mutations'
import type { CommentForm } from './CommentPrompt'
import { CommentPrompt } from './CommentPrompt'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  a:hover {
    text-decoration: underline;
  }
`

const ExistingLink = styled.a`
  white-space: pre;
`

export const CommentButton: React.FC<{
  userId: string
  comment: string
  date: Date
  restrictWidth?: boolean
  hideText?: boolean
  onClick?: () => void
}> = ({ userId, comment, date, restrictWidth, hideText, onClick }) => {
  const addPrompt = usePrompt()

  const refetchQueries = [
    'AllDriverComments',
    'DriverActivityPeriodReport',
    'DriverActivityPeriodReportShallow',
    'AllDynamicColumnsQuery',
    'DriverActivityDayReport',
  ]

  const [updateOrCreateComment] = useMutation(
    UPDATE_OR_CREATE_DRIVER_COMMENT_MUTATION,
    {
      refetchQueries: refetchQueries,
    }
  )

  async function handleAddComment() {
    const { data } = await addPrompt<CommentForm | null>(resolve => (
      <CommentPrompt
        initialData={{
          comment: comment,
        }}
        onSubmit={resolve}
      />
    ))

    if (!data) return

    void updateOrCreateComment({
      variables: {
        input: {
          userId: userId,
          date: format(date, 'yyyy-MM-dd'),
          comment: data.comment,
        },
      },
    })
  }

  return (
    <Wrapper title={comment ? comment : 'Add comment'}>
      {comment && !hideText ? (
        <>
          <ExistingLink
            onClick={evt => {
              evt.stopPropagation()
              onClick?.()
              void handleAddComment()
            }}
          >
            <ElipsedText restrictWidth={restrictWidth}>{comment}</ElipsedText>
          </ExistingLink>
        </>
      ) : (
        <Button
          padding="0.25rem 0.75rem !important"
          height="auto"
          onClick={evt => {
            evt.stopPropagation()
            onClick?.()
            void handleAddComment()
          }}
        >
          <Icon icon="plus" margin="0" />
        </Button>
      )}
    </Wrapper>
  )
}

interface CommentCellProps extends CellProps {
  report: ActivitiesDynamicColumnDayReport
  subColumn: boolean

  userIdOverride?: string
  date?: Date
  comment?: string

  onClick?: () => void
}
export const CommentCell: React.FC<CommentCellProps> = ({
  narrow = true,
  centered = true,
  subColumn = false,
  report,

  userIdOverride,
  date,
  comment,

  onClick,
}) => {
  const paramId = useParam('userId', true)
  const userId = userIdOverride ?? paramId

  if (subColumn) return <td></td>

  const handleClick: MouseEventHandler<HTMLTableCellElement> = event =>
    event.stopPropagation()

  return (
    <Cell onClick={handleClick} narrow={narrow} centered={centered}>
      <CommentButton
        onClick={onClick}
        userId={userId ?? ''}
        date={date ?? parseISO(report.date)}
        comment={comment ?? report.comment?.comment ?? ''}
        restrictWidth={narrow}
      />
    </Cell>
  )
}
